// extracted by mini-css-extract-plugin
module.exports = {"links":"styles_links__2AKUw","noData":"styles_noData__6zzCS"};